import React from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import { Button, Stack } from '@mui/material';

import { PricingToolTabCountProvider } from './PricingToolTabCounts';
import PricingToolToolbar from './PricingToolToolbar';
import { getPricingToolTab } from './constants';
import BlackoutsTab from './tabs/blackouts/BlackoutsTab';
import EgsTab from './tabs/egs/EgsTab';
import ForecastingTab from './tabs/forecasting/ForecastingTab';
import InclusionsTab from './tabs/inclusions/InclusionsTab';
import OverridesTab from './tabs/overrides/OverridesTab';
import PackageOptionsTab from './tabs/packageOptions/PackageOptionsTab';
import ParityCsvTab from './tabs/parityCsv/ParityCsvTab';
import PricingSummaryTab from './tabs/pricingSummary/PricingSummaryTab';
import PropertySetupTab from './tabs/propertySetup/PropertySetupTab';
import SurchargesTab from './tabs/surcharges/SurchargesTab';
import type { PricingToolTab } from './types';

export default function PricingToolPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const activeTab = getPricingToolTab(searchParams.get('tab'));

  const handleTabChange = (tab: PricingToolTab) => {
    const nextSearchParams = new URLSearchParams(location.search);
    nextSearchParams.set('tab', tab);
    navigate({ pathname: location.pathname, search: nextSearchParams.toString() });
  };

  const renderActiveTab = () => {
    switch (activeTab) {
      case 'property-setup':
        return <PropertySetupTab />;
      case 'parity-csv':
        return <ParityCsvTab />;
      case 'package-options':
        return <PackageOptionsTab />;
      case 'inclusions':
        return <InclusionsTab />;
      case 'pricing-summary':
        return <PricingSummaryTab />;
      case 'blackouts':
        return <BlackoutsTab />;
      case 'surcharges':
        return <SurchargesTab />;
      case 'egs':
        return <EgsTab />;
      case 'overrides':
        return <OverridesTab />;
      case 'forecasting':
        return <ForecastingTab />;
      default:
        return null;
    }
  };

  return (
    <PricingToolTabCountProvider>
      <Stack spacing={3}>
        <Stack direction="row" justifyContent="flex-end" spacing={1}>
          <Button disabled size="small" variant="outlined">
            Load Session
          </Button>
          <Button disabled size="small" variant="outlined">
            Save Session
          </Button>
          <Button disabled size="small" variant="contained">
            Export
          </Button>
        </Stack>

        <PricingToolToolbar activeTab={activeTab} onTabChange={handleTabChange} />
        {renderActiveTab()}
      </Stack>
    </PricingToolTabCountProvider>
  );
}
